import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, NavigationExtras, UrlSegment } from '@angular/router';
import { UserService } from './user.service';

/**
 * Service that registers with the router to check user authentication.
 */
@Injectable()
export class AuthGuard  {
    constructor(private userSvc: UserService,
                private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let url: string = state.url;
        let result = this.checkLogin(url) &&  this.checkRoles(route);
        return result;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }

    canLoad(route: Route, segments: UrlSegment[]): boolean {
        let path = segments.join('/');
        let url = `/${path}`;
        let result = this.checkLogin(url) && this.checkRoles(route);
        return result;
    }

    checkLogin(url: string): boolean {
        if (this.userSvc.isAuthenticated) {
            return true;
        }

        // Pass the attempted URL for redirecting
        let navExtras: NavigationExtras = {};
        navExtras.queryParams = {redirectUrl: url}

        // If have details - credentials must have expired.
        if (this.userSvc.details) {
            console.log("User no longer authenticated. Redirecting to login.");

            navExtras.queryParams = {
                redirectUrl: url,
                logout: "Please log back in."
            };
        }

        // Navigate to the login page
        this.router.navigate(['/login'], navExtras);
        return false;
    }

    checkRoles(route: any): boolean {
        let hasRoles = "data" in route && "roles" in route.data;

        if (!hasRoles) {
            return true;
        }

        let roles = route.data["roles"] as Array<string>;

        if (roles.length === 0) {
            return true;
        }
        else if (this.userSvc.roles) {
            let foundRole = this.userSvc.roles.find(userRole => roles.includes(userRole));
            
            return !foundRole ? false : true
        }
        else {
             return false;
        }
    }
}
